var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-body"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1),_c('AppAside',{attrs:{"fixed":""}},[_c('DefaultAside')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }